import { t } from '@lingui/core/macro'
import { DateFormats } from './date-utils'

// TODO: COLOCAR MAIS CASOS AQUI

export const mixed = {
  default: ({ path }) => t`${path} é inválido`,
  required: ({ path }) => t`${path} é um campo obrigatório`
}

export const string = {
  min: ({ path, min }) => t`${path} precisa ter no mínimo ${min} caracteres`,
  max: ({ path, max }) => t`${path} precisa ter no máximo ${max} caracteres`,
  email: ({ path }) => t`${path} precisa ser um email válido`,
  url: ({ path }) => t`${path} precisa ser uma URL válida`
}

export const number = {
  min: ({ path, min }) => t`${path} precisa ser maior ou igual a ${min}`,
  max: ({ path, max }) => t`${path} precisa ser menor ou igual a ${max}`,
  integer: ({ path }) => t`${path} precisa ser inteiro`,
  positive: ({ path }) => t`${path} precisa ser um número positivo`
}

export const date = {
  min: ({ path, min }) => {
    const minf = min.toLocaleString(DateFormats.defaultDateTimeFormat)
    return t`${path} precisa ser depois de ${minf}`
  },
  max: ({ path, max }) => {
    const maxf = max.toLocaleString(DateFormats.defaultDateTimeFormat)
    return t`${path} precisa ser antes de ${maxf}`
  }
}

export const boolean = {}

export const object = {
  noUnknown: ({ path }) =>
    t`Campo ${path} não pode ter chaves não especificadas no formato do objeto`
}

export const array = {
  min: ({ path, min }) => ({
    id: t`{path} precisa ter no mínimo {min} item(s)`.id,
    values: { path, min }
  }),
  max: ({ path, max }) => ({
    id: t`{path} precisa ter no máximo {max} items`.id,
    values: { path, max }
  })
}

export default {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
}
